import { gql } from "apollo-boost"

export const getAssitantsToExport = gql`
query getAllAssitants {
  Assistants {
     assistants {
      id
      folio
      name
      lastName
      maidenName
      gender
      birthdate
      curp
      phone
      state
      municipality
      colony
      type
    }
  }
}`